export const FETCH_PICTURE_BEGIN = "FETCH_PICTURE_BEGIN";
export const FETCH_PICTURE_SUCCESS = "FETCH_PICTURE_SUCCESS";
export const FETCH_PICTURE_FAILURE = "FETCH_PICTURE_FAILURE";

export const DOWNLOAD_PICTURE_BEGIN = "DOWNLOAD_PICTURE_BEGIN";
export const DOWNLOAD_PICTURE_SUCCESS = "DOWNLOAD_PICTURE_SUCCESS";
export const DOWNLOAD_PICTURE_FAILURE = "DOWNLOAD_PICTURE_FAILURE";
